import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:flex md:items-center justify-center flex-wrap md:justify-between bg-white border-b border-gray-200 flex py-4 pl-8" }
const _hoisted_2 = { class: "flex flex-col items-center md:flex-row justify-between" }
const _hoisted_3 = { class: "max-w-lg w-full md:w-56 lg:max-w-xs" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "search",
  class: "sr-only"
}, "Search", -1)
const _hoisted_5 = { class: "relative text-gray-400 focus-within:text-gray-600" }
const _hoisted_6 = { class: "pointer-events-none absolute inset-y-0 pl-3 left-0 flex items-center" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "mt-4 flex-shrink-0 flex md:mt-0 md:ml-4 pr-8" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Advance Filter ")
const _hoisted_10 = { class: "max-w-full overflow-x-auto" }

import { inject, onMounted, ref, computed, watch } from "vue";
import { AxiosInstance } from "axios";
import Navbar from "@/components/tools/Navbar.vue";
import Pagination from "@/components/tools/Pagination.vue";
import { useRoute } from "vue-router";
import DataTable from "@/components/tools/DataTable.vue";
import stringify from "qs-stringify";
import "dayjs/locale/th";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { formatNumber, translate } from "@/utils/tools";
import { SearchIcon } from "@heroicons/vue/solid";
import LoyaltyCategoryEdit from "../../components/dialogs/LoyaltyCategoryEdit.vue";
import LoyaltyCategoryCreateDialog from "../../components/dialogs/LoyaltyCategoryCreateDialog.vue";
import LoyaltyCategoryFilterDialog from "@/components/dialogs/LoyaltyCategoryFilterDialog.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Category',
  setup(__props) {

dayjs.extend(localizedFormat);

const axios = inject("$axios") as AxiosInstance;
const route = useRoute();
const dataRows = ref([]);
const isLoaded = ref(false);
const advanceFilterModal = ref<boolean>(false);
const detailDialogModal = ref<boolean>(false);
const createCategoryModal = ref<boolean>(false);
const editRewardModal = ref<boolean>(false);
const selectedRow = ref({});
const columns = ref([
  {
    label: translate("messages.rewardCategory.id"),
    field: "id",
    sort: true,
  },
  {
    label: translate("messages.rewardCategory.image"),
    field: "imageUrl",
    isImage: true,
    format: () => "",
  },
  {
    label: translate("messages.rewardCategory.name"),
    field: "name",
    isSorted: false,
    sort: true,
  },

  {
    label: translate("messages.rewardCategory.isActive"),
    field: "isActive",
    class: (data: any) => {
      if (data.isActive) {
        return "inline-block text-xs py-1 px-2 rounded-lg bg-green-500 text-white";
      }
      return "inline-block text-xs py-1 px-2 rounded-lg bg-red-500 text-white";
    },
  },

  {
    label: translate("messages.rewardCategory.dateCreated"),
    field: "createdAt",
    align: "left",
    sort: true,
    isSorted: false,
    format: (data: any) => dayjs(data.createdAt).locale("th").format("LLL"),
  },
  {
    label: translate("messages.rewardCategory.type"),
    field: "type",
    sort: true,
    isSorted: false,
  },
  {
    label: "",
    field: "",
    isEdit: true,
    sort: false,
  },
]);
const data = ref([]);
const pageConfig = ref({
  page: 1,
  count: 0,
  pageCount: 0,
  rowsPerPage: 10,
  dataLength: 0,
  search: "",
  sort: [["id", "DESC"]],
});

const filterForm = ref({
  userId: undefined,
  status: undefined,
  id: undefined,
  createdAt: new Date(),
  name: undefined,
  type: undefined,
});

const fetchPageData = async (_reset = false) => {
  isLoaded.value = false;
  const { page, rowsPerPage, sort, search } = pageConfig.value;
  const { type, userId, status, id, name } = filterForm.value;

  const payload = {
    // createdAt,
    page,
    id: id ? String(id) : undefined,
    name: name || search || null,
    userId: userId || null,
    status: status || undefined,
    pageSize: rowsPerPage,
    orderBy: [sort[0]],
    type,
  };
  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/loyalty/api/internal/category/list`
  const { rows, count } = await axios
    .post(url, payload)
    .then(({ data }) => data);

  // if (!rows || rows.length == 0) {
  //    if(pageConfig.value.page == 1){
  //     dataRows.value = []
  //     isLoaded.value = true;
  //     return
  //   }
  //   pageConfig.value.page = page - 1
  //   return
  // }
  pageConfig.value.dataLength = rows.length;

  dataRows.value = rows;
  pageConfig.value.pageCount = Math.ceil(count / rowsPerPage);
  pageConfig.value.count = count;

  pageConfig.value = {
    ...pageConfig.value,
    // count,
    // pageCount: Math.ceil(count / rowsPerPage),
  };
  /** update url to persist page config */
  window.history.replaceState(
    {},
    document.title,
    `?${stringify({ page, rowsPerPage })}`
  );
  isLoaded.value = true;
};

const edit = (e: any) => {
  selectedRow.value = e;
  editRewardModal.value = true;
};

const filterModal = (flag?: number) => {
  if (flag === 1) {
    fetchPageData(true);
  } else {
    fetchPageData(false);
  }
  advanceFilterModal.value = false;
  detailDialogModal.value = false;
};

const doSort = (attName: string) => {
  // not working
  const index = columns.value.findIndex((column) => column.label === attName);
  if (!columns.value[index].sort) {
    return;
  }

  columns.value[index].isSorted = !columns.value[index].isSorted;
  const { sort } = pageConfig.value;
  const mode = sort[0][1];
  let formattedAttName;
  if (attName.toLocaleLowerCase() === "quantity") formattedAttName = "qty";
  if (attName.toLocaleLowerCase() === "name") formattedAttName = "name";
  if (attName === "Category") formattedAttName = "categoryName";
  if (attName === "Date Created") formattedAttName = "id";
  sort[0] = [
    formattedAttName || attName.toLowerCase(),
    mode === "DESC" ? "ASC" : "DESC",
  ];
  fetchPageData(true);
};

watch(
  () => pageConfig.value.page,
  () => fetchPageData()
);
/** fetch data when rows per page was changed */
watch(
  () => pageConfig.value.rowsPerPage,
  () => {
    pageConfig.value.page = Number(route.query.page) || 1;
    fetchPageData();
  }
);
onMounted(() => {
  pageConfig.value.page = Number(route.query.page) || 1;
  pageConfig.value.rowsPerPage = Number(route.query.rowsPerPage) || 10;
  fetchPageData();
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navbar, {
      title: _ctx.$t('messages.rewardCategory.loyaltyCategory')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(SearchIcon), {
                class: "h-5 w-5",
                "aria-hidden": "true"
              })
            ]),
            _withDirectives(_createElementVNode("input", {
              id: "search",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pageConfig.value.search) = $event)),
              class: "block w-full bg-white py-2 pl-10 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm",
              type: "search",
              name: "search",
              placeholder: _ctx.$t('messages.rewardCategory.search'),
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (fetchPageData(true)), ["enter"]))
            }, null, 40, _hoisted_7), [
              [_vModelText, pageConfig.value.search]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (advanceFilterModal.value = true)),
          class: "ml-3 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
        }, [
          _createVNode(_component_font_awesome_icon, {
            class: "text-white mr-2",
            icon: ['far', 'filter'],
            transform: ""
          }),
          _hoisted_9
        ]),
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (createCategoryModal.value = true)),
          class: "ml-3 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
        }, _toDisplayString(_ctx.$t("messages.rewardCategory.createCategory")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(DataTable, {
        columns: columns.value,
        data: dataRows.value,
        onSort: doSort,
        onEdit: edit,
        isLoaded: isLoaded.value
      }, null, 8, ["columns", "data", "isLoaded"]),
      _createVNode(Pagination, {
        config: pageConfig.value,
        "onUpdate:config": _cache[4] || (_cache[4] = ($event: any) => ((pageConfig).value = $event))
      }, null, 8, ["config"]),
      _createVNode(LoyaltyCategoryEdit, {
        show: editRewardModal.value,
        "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((editRewardModal).value = $event)),
        form: selectedRow.value,
        "onUpdate:form": _cache[6] || (_cache[6] = ($event: any) => ((selectedRow).value = $event)),
        onEdited: _cache[7] || (_cache[7] = ($event: any) => (fetchPageData())),
        onClosed: _cache[8] || (_cache[8] = ($event: any) => (fetchPageData()))
      }, null, 8, ["show", "form"]),
      _createVNode(LoyaltyCategoryFilterDialog, {
        show: advanceFilterModal.value,
        "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => ((advanceFilterModal).value = $event)),
        form: filterForm.value,
        "onUpdate:form": _cache[10] || (_cache[10] = ($event: any) => ((filterForm).value = $event)),
        category: filterForm.value.id,
        "onUpdate:category": _cache[11] || (_cache[11] = ($event: any) => ((filterForm.value.id) = $event)),
        onFilter: _cache[12] || (_cache[12] = ($event: any) => (fetchPageData()))
      }, null, 8, ["show", "form", "category"]),
      _createVNode(LoyaltyCategoryCreateDialog, {
        show: createCategoryModal.value,
        "onUpdate:show": _cache[13] || (_cache[13] = ($event: any) => ((createCategoryModal).value = $event)),
        onCreated: _cache[14] || (_cache[14] = ($event: any) => (fetchPageData()))
      }, null, 8, ["show"])
    ])
  ], 64))
}
}

})